import React, {useEffect, useRef, useState} from 'react';
import './styles/App.scss';
import CssBaseline from '@material-ui/core/CssBaseline';
import {createTheme, Grid, ThemeProvider} from "@material-ui/core";
import Home from "./pages/Home";
import ProduseParticipante from "./pages/ProduseParticipante";
import Regulament from "./pages/Regulament";
import usePageScroll from "./hooks/usePageScroll";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import CustomHeader from "./components/CustomHeader";
import PagePoliticaDeConfidentialitate from "./pages/PagePoliticaDeConfidentialitate";
import PageTermeniSiConditii from "./pages/PageTermeniSiConditii";
import PagePoliticaCookies from "./pages/PagePoliticaCookies";
import AppSupport from "./components/AppSupport";
import Menu from "./components/Menu";
import Socials from "./components/Socials";
import MeniuFooter from "./components/MeniuFooter";

// import Video from "./pages/Video";

export type MenuItem = {
    name: string,
    url?: string, goto?: any,
    id: string, offset: number,
    targetBlank?: boolean
}

//import {Breakpoint} from "@material-ui/core/styles/createBreakpoints";
// import Video from "./pages/Video";
//let c: Breakpoint = null;
const theme = createTheme(({
    breakpoints: {
        unit: 'px',
        // Define custom breakpoint values.
        // These will apply to Material-UI components that use responsive
        // breakpoints, such as `Grid` and `Hidden`. You can also use the
        // theme breakpoint functions `up`, `down`, and `between` to create
        // media queries for these breakpoints

        //     (0, 420, 0, 'extrem de mic'),
        // (320, 480, 0, 'Testat pe iPhone SE'), // --- Firefox - dev tools - 320x480
        // (360, 640, 0, 'Galaxy S5'),
        // (412, 732, 0, 'Nexus 6P'), // Chrome - dev tools - Nexus 6P
        // (320, 568, 0, 'iPhone 5 | 5S | SE - 4.0"'), // Chrome - dev tools - iPhone 5
        // (375, 667, 0, 'iPhone 6 | Others - 4.7"'), // Chrome - dev tools - iPhone 6
        // (414, 736, 0, 'iPhone 6 Plus | Others - 5.5"'), // Chrome - dev tools - iPhone 6 Plus
        values: {
            xs: 0,
            sm: 420,
            md: 640,
            lg: 736,
            xl: 1200,


        }
    },
    typography: {
        fontSize: 14,
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            'CentraleSansBold',
            'ARIMAMADURAI-BLACK',
            'Roboto',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        fontWeightMedium: 500,
        body1: {
            fontWeight: 500,
        },
        subtitle1: {
            fontSize: 12,
        },
        button: {
            fontStyle: 'bold',
        },


    },
    palette: {
        background: {
            default: "#021938"
        },
        text: {
            secondary: "#fff",
        },
        primary: {
            main: "#172490",
        },
        secondary: {
            main: "#172490",
        },
        // textSecondary: {
        //     main: {
        //         default: "#ffffff"
        //     }
        // }
    },
}));


theme.typography.h3 = {
    fontSize: AppSupport.pxToVwDesktop(60),

    [theme.breakpoints.only("xs")]: {
        fontSize: AppSupport.pxToVwMob(80),
    },
    // [theme.breakpoints.up("sm")]: {
    //     fontSize: '2.8vw',
    // },
    // [theme.breakpoints.up('md')]: {
    //     fontSize: '2.8vw',
    // },
    // [theme.breakpoints.up('lg')]: {
    //     fontSize: '3.8vw',
    // },
}

// theme.typography.body2 = {
//     ...theme.typography.body2,
//     //fontSize: '0.9vw',
//     [theme.breakpoints.up("sm")]: {
//         fontSize: '0.7vw',
//     },
//     [theme.breakpoints.up('md')]: {
//       //  fontSize: '0.8vw',
//     },
// }

function App() {


    const refHome = useRef(null);
    const refCumParticipi = useRef(null);
    const refInscriere = useRef(null);
    const refProduseParticipante = useRef(null);
    const refCastigatori = useRef(null);
    //const refRegulament = useRef(null);
    const [refList] = useState({
        'home': refHome,
        'cumParticip': refCumParticipi,
        'inscriere': refInscriere,
        'produseParticipante': refProduseParticipante,
        'castigatori': refCastigatori,
        // 'regulament': refRegulament,
    });
    const runScroll = (ref: any = null, name = '', offset = 0) => {
        return () => {
            if (ref && typeof ref.current === "object" && ref.current) {
                if (name === 'inscriere' || name === 'produseParticipante') {
                    (window as any).scrollTo({
                        left: 0,
                        top: offset + ref.current.offsetTop,
                        behavior: 'smooth'
                    });
                } else {
                    (ref.current as any).scrollIntoView({
                        behavior: "smooth"
                    });

                }
            }
        }
    }

    const [menuInPage, setMenuInPage] = useState<boolean>(false);

    const menuElements: MenuItem[] = [
        {
            name: 'Acasă',
            url: '#home',
            goto: runScroll(refList.home),
            id: 'acasa',
            offset: 0
        },
        {
            name: 'Portofoliu',
            url: '#portofoliu',
            goto: runScroll(refList.produseParticipante, 'produseParticipante', -100),
            id: 'portofoliu',
            offset: -150
        },
        {
            name: 'Contact',
            url: "https://danone.ro/contact/",
            goto: 0,
            id: '',
            offset: 550,
            targetBlank: true,
        }
    ];

    const fnScroll = usePageScroll({
        //initTop: true,
        onTop() {
            setMenuInPage(false);
            //console.log('reached top')
        },
        onBottom() {
            //console.log('reached bottom')
        },
        onNavigate(scrollY: number) {
            setMenuInPage(true);
            //console.log(scrollY);
        },
        offsetTop: 100

    });

    useEffect(fnScroll);

    /**
     * Scroll to section on direct link
     */
    // const [gotoState, setGotoState] = useState(false);
    //
    // useEffect(() => {
    //
    //     let {pathname,hash} = window.location;
    //     if (!gotoState && pathname) {
    //         let findElem = menuElements.find(elem => elem.url === hash);
    //         if (findElem && findElem.hasOwnProperty('goto')) {
    //             findElem.goto();
    //             setGotoState(true)
    //         }
    //     }
    //
    // }, [menuElements, gotoState])


    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <Router>
                <Switch>
                    <Route path="/politica-de-confidentialitate">
                        <Grid container spacing={0}>
                            <Menu
                                links={menuElements}
                                navigating={menuInPage}
                                isHomePage={false}
                            />
                            <CustomHeader title={'Politica de confidențialitate'}/>
                            <PagePoliticaDeConfidentialitate/>

                            <Grid container style={({textAlign: 'center'})}>
                                <Socials/>
                                <MeniuFooter/>
                            </Grid>

                        </Grid>
                    </Route>
                    <Route path="/termeni-si-conditii">
                        <Grid container spacing={0}>
                            <Menu
                                links={menuElements}
                                navigating={menuInPage}
                                isHomePage={false}
                            />
                            <CustomHeader title={'Termeni și condiții'}/>
                            <PageTermeniSiConditii/>

                            <Grid container style={({textAlign: 'center'})}>
                                <Socials/>
                                <MeniuFooter/>
                            </Grid>

                        </Grid>
                    </Route>
                    <Route path="/politica-cookies">
                        <Grid container spacing={0}>
                            <Menu
                                links={menuElements}
                                navigating={menuInPage}
                                isHomePage={false}
                            />
                            <CustomHeader title={'Politica cookies'}/>
                            <PagePoliticaCookies/>

                            <Grid container style={({textAlign: 'center'})}>
                                <Socials/>
                                <MeniuFooter/>
                            </Grid>

                        </Grid>
                    </Route>
                    {/*<Route path="/regulament">*/}
                    {/*    <Grid container spacing={0}>*/}
                    {/*        <CustomHeader title={'Regulament'}/>*/}
                    {/*        <PageRegulament/>*/}
                    {/*    </Grid>*/}
                    {/*</Route>*/}
                    <Route path="/*">
                        <Menu links={menuElements}
                              navigating={menuInPage}
                              isHomePage={true}
                        />

                        <Grid container spacing={0}>
                            <Grid item xs={12} id="acasa">
                                <Home forwardRef={refHome} refTriggers={({
                                    'inscriere': runScroll(refInscriere, 'inscriere', -100)
                                })}/>
                            </Grid>

                            <Grid item xs={12} id="portofoliu">
                                <ProduseParticipante forwardRef={refProduseParticipante}/>
                            </Grid>
                            <Grid item xs={12}>
                                <Regulament forwardRef={refCastigatori}/>
                            </Grid>

                        </Grid>
                    </Route>
                </Switch>
            </Router>

        </ThemeProvider>
    );
}

export default App;
